import React from "react";
import PropTypes from "prop-types";
import Script from "react-load-script";
import { SCRIPT_TYPES } from "../../../constants/app-constants";

const GoogleMapScript = ({ scriptLoadedConnect }) => {
    const onLoad = (status) => {
        scriptLoadedConnect(SCRIPT_TYPES.googlemap, status);
    };

    return (<Script
        url={`https://maps.googleapis.com/maps/api/js?key=${process.env.GOOGLE_PLACES_API_KEY}&libraries=places`}
        onError={() => onLoad(false)}
        onLoad={() => onLoad(true)}
    />);
};

GoogleMapScript.propTypes = {
    scriptLoadedConnect: PropTypes.func
};

export default GoogleMapScript;
